<template>
  <div class="mine">
    <div class="mineTop">
      <!-- <img src="../assets/headBg.png" alt="" /> -->
      <div class="mineHead">
        <img v-if="headimgurl" :src="headimgurl" alt="" /><img
          v-else
          src="../assets/headPic.jpg"
          alt=""
        />
      </div>
      <span class="userName">{{ nickName }}</span>
      <!-- <p class="tel">手机号:{{ phone }}</p> -->
      <img
        class="addWx"
        @click="drawer3 = true"
        src="../assets/addWx.png"
        alt=""
      />
      <!-- <div class="vip_card">
        <p class="days">小可愛，您成为沃折扣会员已1488天！</p>
        <div class="vip_info">
          <span class="useful_days" >会员有效期至：{{date}}</span>
          <span class="instro">星巴克8折！</span>
        </div>
        <img src="../assets/renew.png" @click="ImmediatelyRenewal" alt="" />
      </div> -->
    </div>

    <div class="list">
      <div class="eachQudao" v-if="sourceType!=3">
        <div class="eachTit">我的订单</div>
        <ul class="eachList clearfix myorder">
          <li
            v-for="(item, index) in mineArr3"
            @click="toMyOrder(index)"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>

      <div class="eachQudao">
        <div class="eachTit">联联周边游</div>
        <ul class="eachList clearfix">
          <li
            @click="toOrderUrl(1)"
            v-for="(item, index) in mineArr"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>

      <div class="eachQudao">
        <div class="eachTit">千千生活惠</div>
        <ul class="eachList clearfix">
          <li
            @click="toOrderUrl(2)"
            v-for="(item, index) in mineArr"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>

      <div class="eachQudao">
        <div class="eachTit">享库生活</div>
        <ul class="eachList clearfix">
          <li
            @click="toOrderUrl(3)"
            v-for="(item, index) in mineArr"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>
    </div>

    <!-- 添加客服微信 -->

    <!-- <div class="service">
      <div class="serviceTit">联系客服</div>
      <div class="serviceQr">
        <img src="../assets/mineQR.jpg" alt="" />
      </div>
      <div class="serviceDes">长按扫码添加客服</div>
    </div>

    <div class="botAgreement">
      <span @click="drawer1 = true">版权申明</span>
      <span @click="drawer2 = true">隐私政策</span>
    </div>

    <el-drawer
      :visible.sync="drawer1"
      :with-header="false"
      direction="btt"
      size="70%"
    >
      <div class="baMes1">
        版权申明<br />
        <br />
        省钱芝士作为优惠资讯信息聚合平台，倡导对活动信息来源的尊重。<br />
        <br />
        省钱芝士网站上所展示的活动，其版权归属原平台所有。如果您认为我们转摘了您的活动信息，损害了你的利益，请和我们联系，我们将确保您的正当权益，及时清除侵权信息。<br />
        <br />
        豁免申明<br />
        <br />
        省钱芝士是一个优惠信息聚合、共享网络平台，目的是为公众提供丰富的优惠资讯，服务社会公众，不声明也不保证其内容的有效性、
        正确性与可靠性，更不对您的消费构成建议；相关活动、商家产品质量都由信息来源平台负责，与省钱芝士立场无关。对于产品后续服务工作也由相关平台负责，省钱芝士不提供相关服务工作。<br />
        <br />
        <br />
        如有异议请您将该等通知及材料发送到电邮地址：372262003@qq.com<br />
        一旦收到符合版权规则，我们将立即采取包括删除等相应措施。<br />
        <br />
        <br />
        关于我们 | 省钱芝士 版权所有<br />
        <br />
        Copyright © 2021 , All Rights Reserved<br />
      </div>
    </el-drawer>
    <el-drawer
      :visible.sync="drawer2"
      :with-header="false"
      direction="btt"
      size="70%"
    >
      <div class="baMes1">
        省钱芝士隐私政策<br />
        引言<br />
        省钱芝士是由杭州摘星社信息科技有限公司及其关联公司（以下简称“杭州摘星社“或“我们）为您提供淘宝、天猫商品折扣信息、优券领取的导购平台。<br />
        <br />
        我们非常重视您的隐私。本隐私政策是针对杭州摘星社公司省钱芝士做出的隐私方面的陈述与承诺，特别是关于"未成年人信息保护、安全描施、境传输”等部分的约定，建议您详细阅读。<br />
        <br />
        本隐私政策在制定时充分考虑到您的需求，您全面了解我们的个人信息收集和使用惯例，同时确保您最终能控提供给我们的个人信息这一点至关重要。本隐私政策规定我们如何收集、使用、搜露、处理和存储您使用我们的省钱芝士时提供给我们的信息。本隐私政策下“个人信息“指通过信息本身或通过关联其他信息后能够识别特定个人的数据。我们将严格遵守本隐私政策来使用这些信息。<br />
        <br />
        最后，我们希望为用户带来最好的体验。如果您对本隐私政策中描述的个人信息处理实践有任何疑问，请通过lintj@zhaixingshe.com联系我们，以便我们处理您的特殊需求。我们很高兴收到您的反馈。<br />
        <br />
        一、我们收集哪些信息以及如何使用信息<br />
        (一) 您须授权我们收集和使用您个人信息的情形<br />
        <br />
        收集个人信息的目的在于向您提供产品和/或服务，并且保证我们遵守适用的相关法律、法规及其他规范性文件。您有权自行选择是否提供该信息，但多数情况下，如果您不提供，我们可能无法向您提供相应的服务，也无法回应您遇到的问题。这些功能包括：<br />
        <br />
        1. 实现导购服务所必须的功能：优惠券信息展示、推荐和搜索<br />
        <br />
        为了让您快速地找到您所需要的商品和优惠券信息，我们可能会收集您的设备信息（包括
        MEI/OAID（针对
        Android版本）、设备型号、系统版本信息、系统语言）、首次激活渠道和使用时间、应用版本、商品ID、各页面的点击曝光、错误信息来为您提供商品和优惠券信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。<br />
        <br />
        同时，我们也会收集您的第三方账号、IMEI/OAID（针对
        Android版本）、订单信息、购物车和收记录、商品曝光和点击、搜索内容来为您匹配和推荐您可能感兴趣的商品或优惠券信息，为您提供个性化的推荐服务。<br />
        <br />
        (二) 您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的同意：<br />
        <br />
        1、与国家安全、国防安全有关的；<br />
        <br />
        2、与公共安全、公共卫生、重大公共利益有关的；<br />
        <br />
        3、与犯罪侦查、起诉、审判和判决执行等有关的；<br />
        <br />
        4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
        <br />
        5、所收集的个人信息是个人信息主体自行向社会公众公开的；<br />
        <br />
        6、从合法公开披露的信息中收集的您的个人信息的，如合法的新国报道、政府信息公开等报道；<br />
        <br />
        7、根据您的要求签订合同所必需的；<br />
        <br />
        8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；<br />
        <br />
        9、为合法的新闻报道所必需的；<br />
        <br />
        10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br />
        <br />
        (三) 我们从第三方获得您个人信息的情形<br />
        <br />
        在一些法律允许的情况下，我们可能从第三方处获得您的个人信息。例如，您授权第三方账户登录使用我们的服务或授权导入的您在第三方平台的信息如账户、昵称、购物记录、收货地址等。<br />
        <br />
        (四) 非个人信息<br />
        <br />
        我们还可能收集其他无法识别到特定个人的信息（即不属于个人信息的信息），如游客使用特定服务时的统计数据，如商品、页面曝光和点击数据收集，此类信息的目的在于改善我们向您提供的服务。所收集信息的类别和数量取决于您如何使用我们产品和/或服务。就本隐私政策而言，汇总数据被视为非个人信息。如果我们将非个人信息与个人信息结合使用，则在结合使用期间，此类信息将视为个人信息。<br />
        <br />
        二、与第三方服务提供商共享您的个人信息<br />
        本业务中部分服务内容由第三方服务提供商提供，为此我们需要向第三方服务提供商提供您的部分个人信息，例如，在下列情况下，我们可能会与第三方服务提供商共享您的个人信息：<br />
        <br />
        1、搜索服务提供商：本业务中的搜索服务由粉购提供，我们可能会将您的搜索关键词等信息提供给此类服务提供商，用于为您提供商品搜索结果。<br />
        <br />
        2、第三方购物平台：您将跳转至包括淘宝、天猫在内的第三方购物平台完成购物，我们可能会将您的省钱芝士账号提供给此类购物平台，用于为您提供购物和优惠券服务。<br />
        <br />
        如我们与这些第三方分享您的个人信息，我们将采取加密等手段保障您的信息安全。对我们与之共享个人信息的公司、组织，我们会对其数据安全环境进行合理审查，并与其签署严格的数据处理协议，要求第三方对您的信息采取足够的保护措施，严格遵守相关法律法规与监管要求。<br />
        <br />
        三、保留政策<br />
        我们基于本隐私政策中所述的信息收集的目的所必需的期间，或者遵守适用的相关法律要求保留个人信息。个人信息在完成收集目的，或在我们确认您的删除或注销申请后，或我们终止运营相应产品或服务后，我们将停止保留井做删除或匿名化处理。如果是出于公众利益、科学、历史研究或统计的目的，我们将基于适用的法律继续保留相关数据，即使进一步的数据处理与原有的收集目的无关。<br />
        <br />
        您的信息将会保存至中华人民共和国境内。<br />
        <br />
        为给您推荐商品或服务所收集的订单信息、搜索信息、商品信息、收藏和购物车信息将保存180天。<br />
        <br />
        四、您的权利<br />
        (一) 您对您的个人信息享有的权利<br />
        <br />
        根据您所适用的国家或地区法律法规，您有权要求访问、更正、刪除我们持有的与您相关的任何个人信息（以下简称请求）。<br />
        <br />
        任何信息都可通过致信或者电子邮箱地址联系我们。电子邮箱：lintj@zhaixingshe.com<br />
        <br />
        大多数法律要求个人信息主体提出的请求应遵循特定要求，本隐私政策要求您的请求应当符合以下情形：<br />
        <br />
        ·通过我们专门的请求道，并且出于保护的信息安全的考虑，您的请求应当是书面的（除非当地法律明确承认口头申请）；<br />
        <br />
        ·提供足够的信息使我们可以验证您的身份，确保请求人是所请求信息主体本人或合法授权人；<br />
        <br />
        一旦我们获得充分信息确认可处理您的请求时，我们将在适用数据保护法律规定的时间内对您的请求做出回应。具体而言：<br />
        <br />
        ·基于您的要求及适用法律规定，我们可免费提供一份我们已收集井处理的关于您的个人信息记录，如您提出对于相关信息的其他请求，我们可能会基于相关适用法律，并结合实际的管理成本向您收取一笔合理的费用。<br />
        <br />
        ·如果您认为我们持有的关于您的任何信息是不正确或不完整的，可要求基于使用目的更正或完售个人信息。<br />
        <br />
        ·根据您适用的法律法规，您可能有权要求我们删除您的个人数据。我们将会根据您的删除请求进行评估，若满足相应规定，我们将会采取包括技术手段在内的相应步骤进行处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。<br />
        <br />
        我们有权拒绝处理无实质意义/纠缠式重复的请求、损害他人隐私权的请求、极端不现实的请求，要求不相称的技术工作以及根据当地法律无需给予的请求，已经公之于众的信息，保密条件下给出的信息。如果我们认为刪除数据或访问数据的请求的某些方面可能会导致我们无法出于前述反欺诈和安全目的合法使用数据，可能也会予以拒绝。<br />
        <br />
        (二) 撤销同意<br />
        <br />
        ·您可以通过提交请求撤销同意，包括收集、使用和/或披露我们掌握或控制的您的个人信息。根据您所使用的具体服务，可以通过发送电子邮件到lintj@zhaixingshe.com进行相关操作。我们将会在您做出请求后的合理时间内处理您的请求，并且会根据您的请求，在此后不再收集、使用和/或披露您的个人信息。<br />
        <br />
        ·请注意，您撤销同意会导致某些法律后果。根据您授权我们处理信息的范围，这可能导致您不能正常享受我们的产品或服务。但您撤回同或投权的决定，不会影响此前基于您的授权而开展的个人信息处理。<br />
        <br />
        五、第三方网站和服务<br />
        我们的隐私政策不适用于第三方提供的产品或服务。取决于您所使用的省钱芝士的产品或服务，其中可能包括第三方的产品或服务，涉及优惠券领取、搜索服务等类型，其中一些会以第三方网站的链接形式提供，还有一些会以SDK、API等形式接入。当您使用这些产品或服务时，也可能收集您的信息。因此，我们强烈建议您花时间阅读该第三方的隐私政策，就像阅读我们的政策一样。我们不对第三方如何使用他们向您收集的个人信息负责，也不能控制其使用。我们的隐私政策不适用通过我们的服务链接的其他网站。<br />
        <br />
        六、如何联系我们<br />
        如果您对本隐私政策有任何意见或问题，或者您对我们收集、使用或披露您的个人信息有任何问题，请通过下方地址联系我们，并提及“隐私政策”。针对您关于个人信息相关的权利请求、问题咨询等时，我们有专业的团队解决您的问题。如果您的问題本身涉及比较重大的事项，我们可能会要求您提供更多信息。如果您对收到的答复不满，您可以将投诉移交给所在司法辖区的相关监管机构。如果您咨询我们，我们会根据您的实际情况，提供可能适用的相关投诉途径的信息。<br />
        <br />
        联系地址：<br />
        <br />
        杭州市西湖区西溪银泰1号楼888室 杭州摘星社信息科技有限公司<br />
        <br />
        邮政编码：100020<br />
        <br />
        邮箱：lintj@zhaixingshe.com<br />
      </div>
    </el-drawer> -->

    <el-drawer
      :visible.sync="drawer3"
      :with-header="false"
      direction="btt"
      custom-class="QR"
      size="50%"
    >
      <div class="addWorker">
        <p class="title">添加客服微信</p>

        <div class="banner">
          <yd-slider autoplay="1000">
            <yd-slider-item
              class="eachBanner"
              v-for="(item, index) in bannerList"
              :key="index"
            >
              <img :src="item.imgUrl" />
            </yd-slider-item>
          </yd-slider>
        </div>
        <!-- <img src="../assets/mineQR.jpg" alt="" /> -->

        <p class="instro">长按扫码后添加客服微信</p>
        <div class="prizeInstro">
          现加客服<span>大红包</span>！星巴克<span>天天8折!</span>
        </div>
      </div>
    </el-drawer>

    <FootTab></FootTab>
  </div>
</template>

<script>
import Vue from "vue";
import FootTab from "@/components/FootTab.vue";
import { tool } from "../utils";
import { Slider, SliderItem } from "vue-ydui/dist/lib.rem/slider";
Vue.component(Slider.name, Slider);
Vue.component(SliderItem.name, SliderItem);
export default {
  name: "home",
  components: {
    FootTab,
  },
  data() {
    return {
      bannerList: [
        { imgUrl: require("../assets/kf4.jpg") },
        { imgUrl: require("../assets/kf2.jpg") },
        { imgUrl: require("../assets/kf3.jpg") },
      ],
      mineArr: [
        {
          imgUrl: require("../assets/mineIco1.png"),
        },
        {
          imgUrl: require("../assets/mineIco2.png"),
        },
        {
          imgUrl: require("../assets/mineIco3.png"),
        },
        {
          imgUrl: require("../assets/mineIco4.png"),
        },
        {
          imgUrl: require("../assets/mineIco5.png"),
        },
      ],

      mineArr2: [
        {
          imgUrl: require("../assets/mineIco6.png"),
        },
        {
          imgUrl: require("../assets/mineIco7.png"),
        },
        {
          imgUrl: require("../assets/mineIco4.png"),
        },
        {
          imgUrl: require("../assets/mineIco5.png"),
        },
      ],
      mineArr3: [
        {
          imgUrl: require("../assets/myorder_1.png"),
        },
        {
          imgUrl: require("../assets/myorder_2.png"),
        },
        {
          imgUrl: require("../assets/myorder_3.png"),
        },
        {
          imgUrl: require("../assets/myorder_4.png"),
        },
      ],

      defaultImg: require("../assets/banner.png"),

      OrderUrl: "",

      headimgurl: "",
      nickName: "",

      drawer1: false,
      drawer2: false,
      drawer3: false,
      date: 1639704130390, //日期
      phone: "",
      myorderUrl:
        "https://weiq.tongli3d.com/app/index.php?i=9&c=entry&do=index&partner_id=27&m=hc_recharge#/pages/my/my_order/my_order?type=",
   sourceType:''
   };
  },
  activated() {},
  created() {
    // this.phone = localStorage.getItem("phone");
    this.date = tool.formatTime(this.date);
    this.nickName = localStorage.getItem("nickName");
    this.headimgurl = localStorage.getItem("headimgurl");
  },
  mounted() {
    this.sourceType=localStorage.getItem("sourceType")
    var that = this;
    that.http
      .getOrderUrl({
        sourceType: localStorage.getItem("sourceType"),
      })
      .then((res) => {
        console.log(res.data);
        that.OrderUrl = res.data.data;
      });
  },
  methods: {
    ImmediatelyRenewal() {
      console.log("立即续费");
    },
    defImg() {
      // 图片加载失败时加载占位图
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    toOrderUrl(type) {
      if (type == 1) {
        window.location.href = this.OrderUrl[0].url;
      }
      if (type == 2) {
        window.location.href = this.OrderUrl[1].url;
      }
      if (type == 3) {
        window.location.href = this.OrderUrl[2].url;
      }
    },
    toMyOrder(index) {
      switch (index) {
        case 0:
          location.href = this.myorderUrl + "0";
          break;
        case 1:
          location.href = this.myorderUrl + "1";
          break;
        case 2:
          location.href = this.myorderUrl + "2";
          break;
        case 3:
          location.href = this.myorderUrl + "3";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mine {
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.6rem;
  text-align: left;
  background-color: #f5f5f5;

  .mineTop {
    width: 100%;
    height: 5.51rem;
    position: relative;
    background-image: url("../assets/headBg.png");
    background-size: cover;
    .mineHead {
      position: absolute;
      left: 0.3rem;
      width: 0.98rem;
      height: 0.98rem;
      border-radius: 100px;
      overflow: hidden;
      top: 1.2rem;
      //   top: 50%;
      //   transform: translateY(-50%);
    }

    .userName {
      font-size: 0.32rem;
      font-weight: bold;
      color: #333333;
      position: absolute;
      top: 1.3rem;
      left: 1.6rem;
    }
    .tel {
      font-size: 0.22rem;
      color: rgba(0, 0, 0, 0.6);
      position: absolute;
      top: 1.86rem;
      left: 1.6rem;
    }
    .addWx {
      width: 2.46rem;
      height: 0.77rem;
      position: absolute;
      right: 0.23rem;
      top: 1.3rem;
    }

    .vip_card {
      width: 7rem;
      height: 1.43rem;
      margin: 0 auto;
      background-image: url("../assets/vip_card.png");
      background-size: cover;
      position: absolute;
      top: 2.7rem;
      left: 50%;
      transform: translateX(-50%);
      font-size: 0.24rem;
      .days {
        color: #f3deb1;
        position: absolute;
        right: 0.2rem;
        top: 0.35rem;
      }
      .vip_info {
        width: 5.2rem;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        position: absolute;
        top: 0.9rem;
        left: 0.2rem;
        padding-right: 0.2rem;
        span {
          display: inline-block;
        }
        .useful_days {
          color: #716448;
          font-size: 0.22rem;
          transform-origin: left;
          -webkit-transform: scale(0.9);
        }
        .instro {
          color: #b2a17d;
          font-size: 0.22rem;
          transform-origin: left;
          -webkit-transform: scale(0.9);
        }
      }
      img {
        position: absolute;
        right: 0.3rem;
        top: 0.8rem;
        display: inline-block;
        width: 1.56rem;
        height: 0.46rem;
      }
    }
  }
  .list {
    position: relative;
    top: -3.2rem;
  }
  .myorder {
    display: flex;
    justify-content: space-between;
  }

  .eachQudao {
    box-sizing: border-box;
    width: 7rem;
    height: 2.32rem;
    margin: 0.3rem auto 0rem;
    background-color: #fff;
    border-radius: 0.12rem;
    padding: 0.15rem 0.2rem;

    .eachTit {
      font-size: 0.34rem;
      color: #333333;
      font-weight: bold;
      height: 0.8rem;
      line-height: 0.8rem;
      //   border-bottom: 1px solid #f7f4f4;
    }

    .eachList {
      padding: 0.2rem 0rem;
      //   border-bottom: 1px solid #f7f4f4;

      li {
        float: left;
        width: 20%;
        text-align: center;

        img {
          display: inline-block;
          vertical-align: middle;
          height: 0.88rem;
          width: auto;
        }
      }
    }
  }

  .service {
    margin-top: 0.5rem;
    text-align: center;
    margin-bottom: 0.25rem;

    .serviceTit {
      font-size: 0.3rem;
      color: #333333;
    }

    .serviceQr {
      width: 2.4rem;
      height: 2.4rem;
      margin: 0px auto;
    }

    .serviceDes {
      font-size: 0.24rem;
      color: #333333;
    }
  }

  .botAgreement {
    text-align: center;
    margin-top: 0.6rem;

    span {
      display: inline-block;
      vertical-align: middle;
      font-size: 0.28rem;
      margin: 0px 0.2rem;
      color: #ababab;
    }
  }

  .baMes1 {
    padding: 0.3rem;
    text-align: justify;
    font-size: 0.32rem;
    line-height: 0.44rem;
    height: 68vh;
    overflow: auto;
  }
  ::v-deep .QR {
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    overflow: hidden;
  }
  .addWorker {
    // width: 100%;
    // position: absolute;
    // top: 50%;
    // transform:translateY(-50%);
    padding: 0.4rem;
    text-align: center;
    font-size: 0.36rem;

    .title {
      font-weight: bold;
      text-align: left;
    }
    // img {
    //   margin-top: 0.3rem;
    //   display: inline-block;
    //   width: 3.94rem;
    //   height: 3.94rem;
    // }
    .banner {
      // width: 3.94rem;
      width: 3.94rem;
      margin: 0.16rem auto 0;
      border-radius: 0.12rem;
      height: 4.15rem;
      overflow: hidden;

      .yd-slider {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
        .eachBanner {
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .instro {
      margin: 0.1rem;
      color: #6a6a6a;
    }
    .prizeInstro {
      margin-top: 0.2rem;
      color: #070707;
      span {
        color: #be1313;
      }
    }
  }
}
</style>
